import React, {useState, useEffect} from "react";
import { TextArea } from "commons/input-controls";
import AlignButtons from "pages/report-constructor/align-buttons/align-buttons";
import FontBase from "../font-base/font-base";
import s from "./text.module.scss";

const Text = (props) => {
    const [parameters, setParameters] = useState(props.parameters ? {...props.parameters.parameters} : null);
    const [rerender, setRerender] = useState(false);

    useEffect(() => {
        setParameters(props.parameters ? {...props.parameters.parameters} : null);
        setRerender(!rerender);
    }, [props])

    const updateText = (text) => {
        let params = {...parameters};
        params.TEXT = text.replace(/\n/g, "");
        //setParameters(params)
        props.updateComponent(props.index, params)
    }

    const removeParameter = () => {
        props.removeParameter(props.index, 'FONT_PARAMETERS');
    }

    const addParameter = () => {
        props.addParameter(props.index, 'FONT_PARAMETERS');
    }

    const updateParameters = (type, item, selected) => {
        let params = parameters
        let fontParams = {...params[type]}
        fontParams[item] = selected;
        params[type] = fontParams
        if(selected === ''){
            delete params[type][item];
        }
        props.updateComponent(props.index, params)
    }

    const align = (align) => {
        let params = parameters;
        params.ALIGNMENT = align;
        props.updateComponent(props.index, params)
    }

    const textBlock = <TextArea readOnly={props.isReadOnly} value={parameters.TEXT} height={13} rows={5} callback={updateText}/>

    return (
        <div className={s.Text}>

            <div className={s.TextBody}>
                <div className="formRow">
                    <div className="labelText">{props.getValue('TEXT')}</div>
                        { textBlock }
                </div>
                <div className="formRow">
                    <AlignButtons alignItems={align} getValue={props.getValue} alignment={parameters && parameters.ALIGNMENT ? parameters.ALIGNMENT : null}/>
                </div>
                <FontBase 
                        readOnly={props.isReadOnly} 
                        parameters={parameters && parameters.FONT_PARAMETERS  ? {...parameters.FONT_PARAMETERS} : null} 
                        colors={props.colors} 
                        getValue={props.getValue} 
                        updateParameters={updateParameters} 
                        type={'FONT_PARAMETERS'} 
                        removeParameter={removeParameter}
                        index={props.index} 
                        addParameter={addParameter}/>
            </div>
        </div>
    )
}

export default Text;